export enum OperationKind {
    PRODUCT = 0,
    SUM = 1,
    CONCAT = 2,
    REF = 3,
    SUB = 4,
    DATE = 5,
    CONST = 6,
    JOIN = 7,
    POINT = 8,
    PRESET = 9,
    COUNT = 10
}
